import * as yup from 'yup';

import { Currencies } from '@modules/employees/employee-creation/components/creation-form/lib';
import { isValidDate } from '@modules/employees/shared/helpers';

import { reDate } from '@shared/lib/regex';
import { FormDataType } from './bank-edit.types';
import { yupResolver } from '@hookform/resolvers/yup';
import { UseFormProps } from 'react-hook-form';
import { IBankDetails } from '@entities/employee';
import {
  FUTURE_OPEN_ACCOUNT_DATE,
  INVALID_DATE_FORMAT,
} from '@modules/employees/shared/constants/form-error.constants';

const schema = yup
  .object()
  .shape({
    country: yup.string().default(''),
    bankAccount: yup.string().default(''),
    currency: yup.string<Currencies>().default(Currencies.EUR),
    bankNameUa: yup.string().default(''),
    bankNameEn: yup.string().default(''),
    bankAddressUa: yup.string().default(''),
    bankAddressEn: yup.string().default(''),
    bankCode: yup.string().default(''),
    openAccountDate: yup
      .string()
      .matches(reDate, {
        excludeEmptyString: true,
        message: INVALID_DATE_FORMAT,
      })
      .test('bankDate', FUTURE_OPEN_ACCOUNT_DATE, value => isValidDate(value))
      .default(''),
  })
  .required();

export const setup = (defaultValues: IBankDetails) => {
  const options: UseFormProps<FormDataType> = {
    defaultValues: {
      ...defaultValues,
      country: defaultValues.country.id,
    },
    resolver: yupResolver<FormDataType>(schema),
  };

  return options;
};
